import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Row, Button } from "reactstrap";

import FarmerCropHealthMap from "./FarmerCropHealthMap";
import FarmerPlotDetails from "./FarmerPlotDetails";
import FarmerProgressBarChart from "./FarmerProgressBarChart";
import FarmerRainfallIndices from "./FarmerRainfallIndices";
import FarmerReportGaugeChart from "./FarmerReportGaugeChart";
import FarmerSatteliteIndices from "./FarmerSatteliteIndices";
import BankerRainfallIndices from "features/dashboard/BankerLogin/BankerRainfallIndices";
import BankerTemperatureIndices from "features/dashboard/BankerLogin/BankerTemperatureIndices";
import BankerIndices from "features/dashboard/BankerLogin/BankerIndices";
import { usePDF } from "react-to-pdf";
import BankerPlotDetails from "features/dashboard/BankerLogin/BankerPlotDetails";
import FarmerGaugeChart2 from "./FarmerGaugeChart2";

const FarmerCropHealth = ({
  plotData,
  allData,
  RoleAcessParams,
  activeCard,
}) => {
  const [plotDetails, setPlotDetails] = useState({});
  const { toPDF, targetRef } = usePDF({ filename: "Farm Details.pdf" });
  useEffect(() => {
    if (plotData !== undefined) {
      setPlotDetails(plotData);
    }
  }, [plotData]);

  const parseDMY = (d) => {
    const [day, month, year] = d.split("-").map(Number);
    return new Date(year, month - 1, day);
  };
  const scores = plotDetails?.scores;
  const scoreOptions =
    scores?.ACS?.flatMap((entry) =>
      Object.entries(entry).map(([date, value]) => ({
        date,
        value: Number(value),
      }))
    ) ?? [];
  let gauges = [];
  if (scoreOptions.length) {
    const sorted = [...scoreOptions].sort(
      (a, b) => parseDMY(a.date) - parseDMY(b.date)
    );
    const historical = sorted[0];
    const current = sorted[sorted.length - 1];

    gauges =
      historical.date === current.date
        ? [{ ...current, label: "Current" }]
        : [
            { ...historical, label: "Historical" },
            { ...current, label: "Current" },
          ];
  }

  const cropHealthOptions =
    plotDetails?.scores?.crop_health?.flatMap((entry) =>
      Object.entries(entry).map(([date, value]) => ({
        date,
        value: Number(value),
      }))
    ) ?? [];

  let health = [];

  if (cropHealthOptions.length) {
    const sorted = [...cropHealthOptions].sort(
      (a, b) => parseDMY(a.date) - parseDMY(b.date)
    );
    const historical = sorted[0];
    const current = sorted[sorted.length - 1];

    health =
      historical.date === current.date
        ? [{ ...current, label: "Current" }]
        : [
            { ...historical, label: "Historical" },
            { ...current, label: "Current" },
          ];
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-2 offset-md-10 mb-1"></div>
      </div>
      <Row className="">
        <Col
          className={scoreOptions?.length >= 1 ? "col-lg-4 col-12" : "d-none"}
        >
          <Card className="">
            <CardHeader className="d-flex justify-content-between align-items-center">
              {" "}
              <h5 className="m-0 p-1">Farmer Details </h5>
            </CardHeader>
            <CardBody className="p-2 ">
              <div id="gauge-chart" className="e-chart mx-3 mt-1 mb-1 pb-1">
                <BankerPlotDetails
                  details={plotDetails}
                  state={allData?.state_name}
                  district={allData?.district_name}
                  full_name={allData?.full_name}
                  phone_number={allData?.phone_number}
                  unit={allData?.unit_of_land_holding}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col
          className={
            scoreOptions?.length >= 1 ? "col-lg-8 col-12" : "col-lg-12"
          }
        >
          <Row>
            <Col className="col-lg-12 col-12 d-lg-block d-md-block d-none">
              <Card>
                {plotDetails && (
                  <CardBody className="p-1">
                    {(() => {
                      const lat = parseFloat(plotDetails.central_latitude);
                      const lng = parseFloat(plotDetails.central_longitude);
                      const isValidLatLng = !isNaN(lat) && !isNaN(lng);

                      return (
                        <FarmerCropHealthMap
                          boundary={plotDetails?.boundary}
                          acs={plotDetails?.summary_stats?.acs}
                          // height="35vh"
                          height="43vh"
                          boundaryUpdated={true}
                          latLong={isValidLatLng ? [lat, lng] : undefined}
                        />
                      );
                    })()}
                  </CardBody>
                )}
              </Card>
            </Col>
          </Row>
        </Col>
        <Row className="mx-auto">
          {scoreOptions?.length === 0 && (
            <Col className="col-lg-4 col-12">
              <Card className="" style={{ height: "326px" }}>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  {" "}
                  <h5 className="m-0 p-1">Farmer Details </h5>
                </CardHeader>
                <CardBody className="p-2 ">
                  <div id="gauge-chart" className="e-chart mx-3 mt-1 mb-1 pb-1">
                    <BankerPlotDetails
                      details={plotDetails}
                      state={allData?.state_name}
                      district={allData?.district_name}
                      full_name={allData?.full_name}
                      phone_number={allData?.phone_number}
                      unit={allData?.unit_of_land_holding}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          )}
          {scoreOptions?.length >= 1 ? (
            <>
              <Col className="col-lg-6 col-12 d-lg-block d-md-block d-none">
                <Card className="">
                  <CardHeader>
                    <div className="relative w-full">
                      <h5 className="flex items-center justify-between rounded-topp-3 p-1 pr-10">
                        <span>
                          {/* <i className="mdi mdi-chart-line fs-6 me-2"></i> */}
                          {RoleAcessParams.includes("HCL")
                            ? "Farm Score"
                            : "Agriculture Credit Score (Historical)"}
                        </span>

                        <a
                          href="https://firebasestorage.googleapis.com/v0/b/agrani-farmer.firebasestorage.app/o/acs.pdf?alt=media&token=caf9a11e-3bbc-46e1-ab6b-04edc879ec7b"
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-gray-600 hover:text-blue-600"
                          title="Download PDF"
                          style={{ float: "right" }}
                        >
                          <i className="mdi mdi-tray-arrow-down text-xl"></i>
                        </a>
                      </h5>
                    </div>
                  </CardHeader>
                  <CardBody className="p-5">
                    <div id="gauge-chart" className="text-center pb-1">
                      <FarmerReportGaugeChart
                        farmerDataCl={
                          gauges[1]?.value ?? plotDetails?.summary_stats?.acs
                        }
                        chartName={
                          RoleAcessParams?.includes("HCL")
                            ? "Farm Score"
                            : "Agriculture Credit Score"
                        }
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col className="col-lg-6 col-12 d-lg-block d-md-block d-none">
                <Card className="">
                  <CardHeader>
                    <div className="relative w-full">
                      <h5 className="flex items-center justify-between rounded-topp-3 p-1 pr-10">
                        <span>
                          {/* <i className="mdi mdi-chart-line fs-6 me-2"></i> */}
                          {RoleAcessParams.includes("HCL")
                            ? "Farm Score"
                            : "Agriculture Credit Score (Current)"}
                        </span>

                        <a
                          href="https://firebasestorage.googleapis.com/v0/b/agrani-farmer.firebasestorage.app/o/acs.pdf?alt=media&token=caf9a11e-3bbc-46e1-ab6b-04edc879ec7b"
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-gray-600 hover:text-blue-600"
                          title="Download PDF"
                          style={{ float: "right" }}
                        >
                          <i className="mdi mdi-tray-arrow-down text-xl"></i>
                        </a>
                      </h5>
                    </div>
                  </CardHeader>
                  <CardBody className="p-5">
                    <div id="gauge-chart" className="text-center pb-1">
                      <FarmerReportGaugeChart
                        farmerDataCl={gauges[0]?.value}
                        chartName={
                          RoleAcessParams?.includes("HCL")
                            ? "Farm Score"
                            : "Agriculture Credit Score"
                        }
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </>
          ) : (
            <Col className="col-lg-4 col-12 d-lg-block d-md-block d-none">
              <Card className="">
                <CardHeader>
                  <div className="relative w-full">
                    <h5 className="flex items-center justify-between rounded-topp-3 p-1 pr-10">
                      <span>
                        {/* <i className="mdi mdi-chart-line fs-6 me-2"></i> */}
                        {RoleAcessParams.includes("HCL")
                          ? "Farm Score"
                          : "Agriculture Credit Score"}
                      </span>

                      <a
                        href="https://firebasestorage.googleapis.com/v0/b/agrani-farmer.firebasestorage.app/o/acs.pdf?alt=media&token=caf9a11e-3bbc-46e1-ab6b-04edc879ec7b"
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-600 hover:text-blue-600"
                        title="Download PDF"
                        style={{ float: "right" }}
                      >
                        <i className="mdi mdi-tray-arrow-down text-xl"></i>
                      </a>
                    </h5>
                  </div>
                </CardHeader>
                <CardBody className=" " style={{ padding: "0px" }}>
                  <div id="gauge-chart" className="text-center pb-1">
                    <FarmerReportGaugeChart
                      farmerDataCl={plotDetails?.summary_stats?.acs}
                      chartName={
                        RoleAcessParams?.includes("HCL")
                          ? "Farm Score"
                          : "Agriculture Credit Score"
                      }
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          )}
          {health?.length >= 1 ? (
            <>
              <Col className="col-lg-6 d-lg-block d-md-block d-none">
                <Card className="">
                  <CardHeader>
                    <h5 className="m-0 p-1">Crop Health Score (Historical) </h5>
                  </CardHeader>
                  <CardBody className=" p-0 pb-1">
                    <div>
                      <FarmerProgressBarChart
                        farmerDataCl={
                          health[1]?.value ??
                          plotDetails?.summary_stats?.crop_health
                        }
                        chartName="Crop Health Score"
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col className="col-lg-6 d-lg-block d-md-block d-none">
                <Card className="">
                  <CardHeader>
                    <h5 className="m-0 p-1">Crop Health Score (Current) </h5>
                  </CardHeader>
                  <CardBody className=" p-0 pb-1">
                    <div>
                      <FarmerProgressBarChart
                        farmerDataCl={health[0].value}
                        chartName="Crop Health Score"
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </>
          ) : (
            <Col className="col-lg-4 d-lg-block d-md-block d-none">
              <Card className="">
                <CardHeader>
                  <h5 className="m-0 p-1">Crop Health Score </h5>
                </CardHeader>
                <CardBody className=" p-0 pb-1">
                  <div>
                    <FarmerProgressBarChart
                      farmerDataCl={plotDetails?.summary_stats?.crop_health}
                      chartName="Crop Health Score"
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          )}
        </Row>
      </Row>
      <div className="d-lg-none d-md-none d-block">
        <Card className="transparent_card">
          <CardHeader
            className="d-lg-block d-md-block d-none"
            style={{ backgroundColor: "transparent" }}
          >
            <h5 className="m-0 p-1 bg-secondary2">Analytics</h5>
          </CardHeader>
          <CardBody className="p-lg-4 p-md-4 p-0">
            <Row>
              <Col className="col-lg-4 col-12 offset-md-2">
                <Card className="">
                  <CardHeader>
                    <h5 className="m-0 p-1">Agriculture Credit Score</h5>
                  </CardHeader>
                  <CardBody className=" " style={{ padding: "0px" }}>
                    <div id="gauge-chart" className="text-center mb-2 pb-3">
                      <FarmerGaugeChart2
                        farmerDataCl={plotDetails?.summary_stats?.acs}
                        // scores={plotDetails?.scores}
                        chartName={
                          RoleAcessParams.includes("HCL")
                            ? "Farm Score"
                            : "Agriculture Credit Score"
                        }
                        scores={plotDetails?.scores}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col className="col-lg-4">
                <Card className="">
                  <CardHeader>
                    {" "}
                    <h5 className="m-0 p-1">Crop Health Score</h5>
                  </CardHeader>
                  <CardBody className="mx-5 p-1">
                    <div>
                      <FarmerProgressBarChart
                        farmerDataCl={plotDetails?.summary_stats?.crop_health}
                        chartName="Crop Health Score"
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
      <Col className="col-lg-12 col-12 bg-transparent  ">
        {plotDetails?.summary_stats?.current_indices ? (
          <Card>
            <CardHeader>
              <h5 className="m-0 p-1">Satellite Derived Indices</h5>
            </CardHeader>{" "}
            <CardBody className="p-2">
              <div id="gauge-chart" className="e-chart mx-3 mt-1 mb-1 pb-3">
                <BankerIndices
                  data={
                    plotDetails?.summary_stats?.current_indices.season_wise_msi
                  }
                />
              </div>
            </CardBody>
          </Card>
        ) : (
          ""
        )}
      </Col>

      <Col className="col-lg-12 col-12 bg-transparent  ">
        {plotDetails?.summary_stats?.current_indices ? (
          <Card>
            <CardHeader>
              <h5 className="m-0 p-1">Rainfall</h5>
            </CardHeader>{" "}
            <CardBody className="p-2">
              <div id="gauge-chart" className="e-chart mx-3 mt-1 mb-1 pb-3">
                <BankerRainfallIndices
                  indices={
                    plotDetails?.summary_stats?.current_indices
                      ?.season_wise_rainfall
                  }
                />
              </div>
            </CardBody>
          </Card>
        ) : (
          ""
        )}
        {/* <Card>
          <CardBody className="mt-2 p-lg-4 p-md-4 p-3">
            <h5 className="bg-secondary2 p-1">Satellite Derived Indices</h5>
            <FarmerSatteliteIndices
              fid={417}
              indices={plotDetails?.summary_stats?.indices}
            />
            
          </CardBody>
        </Card> */}
        <Col className="col-lg-12 bg-transparent mt-2" id="">
          {/* <Card>
            <CardBody className="mt-2 p-lg-4 p-md-4 p-3">
              <h5 className="bg-secondary2 p-1 ">Rainfall Trend</h5>
              <FarmerRainfallIndices
                fid={417}
                indices={plotDetails?.summary_stats?.rainfall}
              />
            </CardBody>
          </Card> */}
          {plotDetails?.summary_stats?.current_indices ? (
            <Card>
              <CardHeader>
                <h5 className="m-0 p-1">Temperature</h5>
              </CardHeader>{" "}
              <CardBody className="p-2">
                <div id="gauge-chart" className="e-chart mx-3 mt-1 mb-1 pb-3">
                  <BankerTemperatureIndices
                    indices={
                      plotDetails?.summary_stats?.current_indices
                        ?.season_wise_temperature
                    }
                  />
                </div>
              </CardBody>
            </Card>
          ) : (
            ""
          )}
        </Col>
      </Col>
    </div>
  );
};

export default FarmerCropHealth;
